<template>
<div class="d-inline-block d-flex">
  <span class="my-auto ml-4">
    <span class="text-gray-800 mr-2 d-inline-block">
      <span class="d-none d-sm-inline">{{ $t('hello') }}, </span>
      <span class="d-none d-sm-inline" v-if="!user_is_admin">{{ $t('family') }}  </span> 
      <span v-if="!user_is_admin" class="font-weight-bold">{{ lastname }}</span>
      <span v-else class="font-weight-bold">{{ username }}</span>
    </span>
    <small class="d-none d-xl-block text-gray-600">{{ $t('last_access') }}:
      <span id="last-login-text">{{ user_last_access }}</span>
    </small>
  </span>

  <div class="dropdown px-3 d-inline-block">
    <button class="btn btn-default dropdown-toggle pointer" role="button" id="userDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
      <span class="caret"></span>
    </button>
    <div class="dropdown-menu dropdown-menu-right shadow" aria-labelledby="userDropdown">
      <a v-if="user_is_superAdmin" class="dropdown-item" :href="`${baseUrl}aadmin`"> 
        <i class="fas fa-user-lock fa-sm fa-fw mr-2 text-gray-400"></i> {{ $t('Go_to_admin') }}
      </a>
      <a v-if="user_is_admin && !user_is_superAdmin" class="dropdown-item" :href="`${baseUrl}aadmin/#/commands`"> 
        <i class="fas fa-user-lock fa-sm fa-fw mr-2 text-gray-400"></i> {{ $t('Go_to_admin') }}
      </a>
      <router-link class="dropdown-item" to="settings"> 
        <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i> {{ $t('Change_password') }}
      </router-link>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="#" @click="logout"> 
        <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i> {{ $t('Logout') }}
      </a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'UserInfo',
  data(){
    return {
      user_last_access: null
    }
  },
  mounted: function(){
    this.user_last_access = this.$store.getters.user.previous_login ? moment(this.$store.getters.user.previous_login).format("DD MMM, HH:mm") : '-'
  },
  methods: {
    logout: function(e){
      e.preventDefault()
      this.$store.dispatch('logout').then(() => { this.$router.push("/login") })
    }
  },
  computed: {
    baseUrl: function() {
      let getUrl = window.location;
      let baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
      return baseUrl
    },
    user_is_admin: function(){
      return this.$store.getters.user_isAdmin
    },
    username: function(){
      return this.$store.getters.username
    },
    lastname: function(){
      return this.$store.getters.lastname
    },
    user_is_superAdmin: function(){
      return this.$store.getters.user_isSuperAdmin
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  },
  watch: {
    current_lang: function(){
      this.user_last_access = moment(this.$store.getters.user.previous_login).format("DD MMM, HH:mm") || '-'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
